var emitter = require('./emitter'),
	common = require('./common');

function Events(){

	emitter.emit('app:init');

	common.$window.on('load', function loadEvent() {
	    emitter.emit('page:load');
	});

	common.$window.on('resize', _.debounce(function resizeEvent() {
	    emitter.emit('page:resize');
	}, 100));

}


module.exports = Events;



/** WEBPACK FOOTER **
 ** ./base/events.js
 **/